class Tooltip {
    constructor() {
        $('.tooltip').tipr({
            'speed': 300,
            'mode': 'above',
            'marginAbove': -250
        });
    }
}

export default Tooltip;